import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import './App.css'; // brand CSS variables (--brand-navy/--brand-orange/--text-light/--spacing-*/--shadow-*) + .container — Header/Footer/pages depend on these
import JobsListPage from './pages/JobsListPage';
import JobDetailPage from './pages/JobDetailPage';
import ApplyPage from './pages/ApplyPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import NotFound from './pages/NotFound';

// Reset scroll on every client-side route change. Two things broke the naive `scrollTo(0,0)`:
// (1) the browser's default `scrollRestoration:'auto'` restores the PREVIOUS page's scroll after
// React runs, and (2) `index.css` sets `html{scroll-behavior:smooth}` so a plain scrollTo animates
// and gets overridden mid-flight. Net effect: clicking a link below the fold (a job card after
// scrolling, or "Apply for this job" at the bottom of a long detail page) landed you scrolled-down
// on the new page — under the sticky header it looked like a blank page until you refreshed.
// Fix: opt out of scroll restoration + force an INSTANT jump to top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<JobsListPage />} />
        <Route path="/jobs/:slug" element={<JobDetailPage />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/apply/:slug" element={<ApplyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
